/* assets/of-analytics.js
 * Thin GA4 event helper for Otto Frei custom tracking.
 * Loaded on all pages via theme.liquid (defer).
 */
(function () {
  // Capture utm_placement from URL on landing, persist for session.
  var placement = new URLSearchParams(location.search).get('utm_placement');
  if (placement) {
    try { sessionStorage.setItem('of_utm_placement', placement); } catch (e) {}
  }
})();

window.OFTrack = {
  _sent: new Set(),
  /* F20 (2026-09-06 review): this was has('of_debug'), which tests PRESENCE,
   * not value, so the documented off switch ?of_debug=0 turned debug logging
   * ON and every OFTrack call console-logged its full parameter set on a
   * production page. Bare ?of_debug (no value) still means on; 0, false and
   * off mean off, in any case. Reported as July U8-10. */
  _debug: (function () {
    var v = new URLSearchParams(location.search).get('of_debug');
    if (v === null) return false;                 // param absent
    var t = String(v).trim().toLowerCase();
    // URLSearchParams reports both bare `?of_debug` and explicit `?of_debug=`
    // as the empty string. The bare form is the documented switch (CLAUDE.md),
    // so it stays ON; an explicitly emptied value reads as off, like 0/false/
    // off/no.
    if (t === '') return /[?&]of_debug(?:&|$)/.test(location.search);
    return t !== '0' && t !== 'false' && t !== 'off' && t !== 'no';
  })(),

  _placement() {
    try { return sessionStorage.getItem('of_utm_placement'); } catch (e) { return null; }
  },

  event(name, params) {
    var p = Object.assign({ event_category: 'otto_frei' }, params || {});
    var placement = this._placement();
    if (placement) p.utm_placement = placement;
    if (typeof gtag === 'function') gtag('event', name, p);
    if (this._debug) console.log('[OFTrack]', name, p);
  },

  once(name, key, params) {
    var id = name + ':' + key;
    if (this._sent.has(id)) return;
    this._sent.add(id);
    this.event(name, params);
  }
};

/* Judge.me testimonials carousel (homepage `apps` section, block
 * judge_me_reviews_testimonials_carousel_G48DY8). Nothing measured it, so on
 * 2026-09-17 Rhett asked for two weeks of click data before deciding whether
 * the block stays. One delegated listener on document: the carousel renders
 * after Judge.me fetches reviews, so a direct bind would miss it. Cards are
 * `.jdgm-testimonial` and each links to the reviewed product. Params:
 * `target` = product handle, `index` = card position, `surface` = template. */
if (typeof document !== 'undefined') document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest ? e.target.closest('.jdgm-testimonial a[href]') : null;
  if (!a || !window.OFTrack) return;
  var card = a.closest('.jdgm-testimonial');
  var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
  window.OFTrack.event('of_review_carousel_click', {
    target: m ? m[1] : 'other',
    index: card ? Number(card.getAttribute('data-card-index')) : -1,
    surface: (document.body.className.match(/template-(\S+)/) || [])[1] || 'unknown'
  });
}, true);
